import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { getConfig } from '../../../utils/config';

const TotalReferral = ({ active, setActive, userAccountSummary, allLeads }) => {
    const config = getConfig;
    const [showWelcomeMessage, setShowWelcomeMessage] = useState(true);
    const isInternalWebview = useSelector((state) => state.webView.internalWebview);
    const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);

    // const changeStatus = (e) => {
    //     setActive(e.target.id);
    // };
    const changeStatus = (status) => {
        setActive(status);
    };

    const history = useHistory();
    const { userRole } = useSelector((state) => state.auth);

    // const hasReferrals =
    //     userAccountSummary && userAccountSummary.leadSubmissions > 0;
    const handleReferNowClick = () => {
        window?.webengage?.track('ReferralSection', { From: 'Earn More' });
        if (isInternalWebview && isIOS) {
            var valueToSend = {
                type: 'OPEN_REFERRAL_IN_BROWSER',                                  
            };
            window?.webkit?.messageHandlers?.jsMessageHandler.postMessage(
                valueToSend
            );
        } else {
            history.push('/gift-and-earn');
        }
    };

    return (
        <div className="">
            {showWelcomeMessage && allLeads.length === 0 ? (
                <div class="flex md:flex-row flex-col items-center md:justify-between py-8 md:px-5 md:py-10 bg-transparent border border-gray-300 rounded-lg shadow-sm mt-4">
                    <div class="flex items-center">
                        <div class="mr-4">
                            <svg
                                id="_059---Money-Bag"
                                data-name="059---Money-Bag"
                                xmlns="http://www.w3.org/2000/svg"
                                className=" w-[55px] h-[55px] md:w-[70px] md:h[70.005px]"
                                viewBox="0 0 70 70.005"
                            >
                                <path
                                    id="Shape"
                                    d="M52.081,62.525h-23.2V48.017c0-2.007-3.518-3.627-7.858-3.627A15.859,15.859,0,0,0,18,44.668V31.5c3.824-8.916,10.347-15.4,16.14-18.268a6.559,6.559,0,0,0,3.421.931h6.77a6.529,6.529,0,0,0,3.446-.955c2.636,1.306,14.52,8.112,18.812,26.344C71.425,60.107,56.917,62.525,52.081,62.525Z"
                                    transform="translate(1.226 -0.983)"
                                    fill="#ffdc00"
                                />
                                <path
                                    id="Shape-2"
                                    data-name="Shape"
                                    d="M61.813,39.554C57.521,21.322,45.637,14.516,43,13.21a6.308,6.308,0,0,1-2.146.816C45,16.5,54.456,23.716,58.186,39.554c4.836,20.553-9.672,22.971-14.508,22.971H47.3C52.141,62.525,66.649,60.107,61.813,39.554Z"
                                    transform="translate(6.003 -0.983)"
                                    fill="#fec108"
                                />
                                <path
                                    id="Shape-3"
                                    data-name="Shape"
                                    d="M51.188,3.415c.012,2.66-.52,8.463-4.776,11.788a3.779,3.779,0,0,1-.508.351,6.529,6.529,0,0,1-3.446.955h-6.77a6.559,6.559,0,0,1-3.421-.931c-.181-.121-.363-.242-.532-.375C27.48,11.877,26.96,6.074,26.96,3.415A1.209,1.209,0,0,1,28.628,2.3c1.548.653,2.067,2.116,4.413,2.116,3.01,0,3.01-2.418,6.021-2.418s3.022,2.418,6.045,2.418c2.345,0,2.865-1.475,4.413-2.116a1.209,1.209,0,0,1,1.668,1.112Z"
                                    transform="translate(3.924 -0.79)"
                                    fill="#ffdc00"
                                />
                                <path
                                    id="Shape-4"
                                    data-name="Shape"
                                    d="M47.467,2.266A9.758,9.758,0,0,0,45.508,3.6c-.017,2.746-.627,8.329-4.773,11.568a3.779,3.779,0,0,1-.508.351,6.529,6.529,0,0,1-3.446.955h3.627a6.529,6.529,0,0,0,3.446-.955,3.779,3.779,0,0,0,.508-.351c4.253-3.325,4.785-9.128,4.773-11.788a1.209,1.209,0,0,0-1.668-1.112Z"
                                    transform="translate(5.814 -0.754)"
                                    fill="#fec108"
                                />
                                <ellipse
                                    id="Oval"
                                    cx="8.252"
                                    cy="3.537"
                                    rx="8.252"
                                    ry="3.537"
                                    transform="translate(12.381 5.895)"
                                    fill="#ffdc00"
                                />
                                <path
                                    id="Shape-5"
                                    data-name="Shape"
                                    d="M26.717,9V21.066a39.655,39.655,0,0,0-7.254,11.316V25.926c0-2.007-3.518-3.627-7.858-3.627-.206,0-.4,0-.6.012V9c0,2.007,3.518,3.627,7.858,3.627S26.717,11.007,26.717,9Z"
                                    transform="translate(1.705 0.673)"
                                    fill="#ff9801"
                                />
                                <path
                                    id="Shape-6"
                                    data-name="Shape"
                                    d="M20.717,23.627c0,2.007-3.518,3.627-7.858,3.627S5,25.634,5,23.627c0-1.91,3.192-3.47,7.254-3.615.206-.012.4-.012.6-.012C17.2,20,20.717,21.62,20.717,23.627Z"
                                    transform="translate(1.045 2.08)"
                                    fill="#ffdc00"
                                />
                                <path
                                    id="Shape-7"
                                    data-name="Shape"
                                    d="M20.717,23V42.622c-2.841.544-4.836,1.838-4.836,3.349v12.09c0-2.007-3.518-3.627-7.858-3.627A15.86,15.86,0,0,0,5,54.712V23c0,2.007,3.518,3.627,7.858,3.627S20.717,25.007,20.717,23Z"
                                    transform="translate(1.045 1.287)"
                                    fill="#ff9801"
                                />
                                <path
                                    id="Shape-8"
                                    data-name="Shape"
                                    d="M16.717,52.627c0,2.007-3.518,3.627-7.858,3.627S1,54.634,1,52.627c0-1.511,1.995-2.8,4.836-3.349A15.86,15.86,0,0,1,8.858,49C13.2,49,16.717,50.62,16.717,52.627Z"
                                    transform="translate(0.209 6.497)"
                                    fill="#ffeb3a"
                                />
                                <path
                                    id="Shape-9"
                                    data-name="Shape"
                                    d="M16.717,52v6.045c0,2.007-3.518,3.627-7.858,3.627S1,60.052,1,58.045V52c0,2.007,3.518,3.627,7.858,3.627S16.717,54.007,16.717,52Z"
                                    transform="translate(0.209 7.124)"
                                    fill="#ffdc00"
                                />
                                <path
                                    id="Shape-10"
                                    data-name="Shape"
                                    d="M29.717,42.627c0,2.007-3.518,3.627-7.858,3.627S14,44.634,14,42.627c0-1.511,1.995-2.8,4.836-3.349A15.859,15.859,0,0,1,21.858,39C26.2,39,29.717,40.62,29.717,42.627Z"
                                    transform="translate(2.171 5.158)"
                                    fill="#ffeb3a"
                                />
                                <path
                                    id="Shape-11"
                                    data-name="Shape"
                                    d="M29.717,42V57.717c0,2.007-3.518,3.627-7.858,3.627S14,59.724,14,57.717V42c0,2.007,3.518,3.627,7.858,3.627S29.717,44.007,29.717,42Z"
                                    transform="translate(2.171 5.034)"
                                    fill="#ffdc00"
                                />
                                <g id="Group_11226" data-name="Group 11226">
                                    <path
                                        id="Shape-12"
                                        data-name="Shape"
                                        d="M55.147,17.409c5.788.436,7.651,2.844,7.706,2.917a1.167,1.167,0,0,0,1.932-1.308c-.084-.126-1.7-2.441-6.417-3.5A5.352,5.352,0,0,0,60.32,11.5a5.991,5.991,0,0,0-4.462-5.435,21.282,21.282,0,0,0,.156-2.54A2.333,2.333,0,0,0,52.77,1.382a6.666,6.666,0,0,0-1.624,1.042,3.008,3.008,0,0,1-2.182.91,3.011,3.011,0,0,1-2.178-.91,5.367,5.367,0,0,0-7.283,0,3.068,3.068,0,0,1-4.361,0,6.676,6.676,0,0,0-1.619-1.041,2.333,2.333,0,0,0-3.24,2.144c0,2.9.574,8.081,4.208,11.558a32.188,32.188,0,0,0-5.323,4.05v-8.8c0-2.66-3.763-4.667-8.75-4.667s-8.75,2.007-8.75,4.667V22.089c-4.092.408-7,2.246-7,4.579V56.344C1.848,57.1,0,58.637,0,60.5v5.834C0,69,3.763,71,8.75,71c4.46,0,7.934-1.607,8.619-3.85a13.106,13.106,0,0,0,6.549,1.517c4.988,0,8.75-2.007,8.75-4.667V48.836c0-2.66-3.763-4.667-8.75-4.667a17.314,17.314,0,0,0-1.75.088V26.668c0-2.555-3.473-4.5-8.167-4.652V13.565A13.287,13.287,0,0,0,20.418,15a13.287,13.287,0,0,0,6.417-1.436v7.957c-.768.86-1.541,1.8-2.3,2.835a1.167,1.167,0,0,0,1.881,1.378,35.37,35.37,0,0,1,2.406-2.917c.009-.01.017-.021.027-.03a30.671,30.671,0,0,1,7.744-6.206,7.4,7.4,0,0,0,1.8.6l-3.008,2.807a1.167,1.167,0,0,0,1.594,1.706l4.667-4.353h.372v3.5a1.167,1.167,0,0,0,2.333,0V17.334h.372l4.667,4.353a1.167,1.167,0,1,0,1.594-1.706l-3.028-2.819a7.35,7.35,0,0,0,1.789-.6c3.084,1.668,13.22,8.26,17.017,24.374,1.651,7.014,1.056,12.38-1.768,15.945-3.612,4.556-9.88,4.789-11.1,4.789H37.335a1.167,1.167,0,0,0,0,2.333H53.891c1.983,0,8.756-.41,12.927-5.674,3.288-4.152,4.032-10.184,2.21-17.928-2.875-12.217-9.266-19.3-13.882-22.993ZM8.75,58.17c3.858,0,6.417,1.4,6.417,2.333s-2.559,2.333-6.417,2.333-6.417-1.4-6.417-2.333S4.892,58.17,8.75,58.17Zm0,10.5c-3.858,0-6.417-1.4-6.417-2.333v-2.6A13.287,13.287,0,0,0,8.75,65.17a13.287,13.287,0,0,0,6.417-1.436v2.6C15.168,67.27,12.609,68.671,8.75,68.671Zm15.168-2.333c-3.858,0-6.417-1.4-6.417-2.333V52.067A13.287,13.287,0,0,0,23.918,53.5a13.287,13.287,0,0,0,6.417-1.436V64C30.335,64.937,27.776,66.337,23.918,66.337Zm6.417-17.5c0,.933-2.559,2.333-6.417,2.333S17.5,49.77,17.5,48.836,20.06,46.5,23.918,46.5,30.335,47.9,30.335,48.836Zm-15.168,0v8.437A13.287,13.287,0,0,0,8.75,55.837,17.311,17.311,0,0,0,7,55.924V29.9a13.287,13.287,0,0,0,6.417,1.436A13.287,13.287,0,0,0,19.834,29.9V44.677C17.016,45.434,15.168,46.969,15.168,48.836Zm4.667-22.168c0,.933-2.559,2.333-6.417,2.333S7,27.6,7,26.668s2.559-2.333,6.417-2.333S19.834,25.735,19.834,26.668Zm.583-14c-3.858,0-6.417-1.4-6.417-2.333S16.559,8,20.418,8s6.417,1.4,6.417,2.333S24.276,12.667,20.418,12.667ZM57.987,11.5c0,1.912-2.071,3.482-4.667,3.5a6.025,6.025,0,0,1-1.29-.148A13.834,13.834,0,0,0,55.437,8.4a3.575,3.575,0,0,1,2.549,3.1ZM33.681,4.244a5.363,5.363,0,0,0,7.278,0,3.071,3.071,0,0,1,4.364,0,5.261,5.261,0,0,0,3.641,1.423,5.265,5.265,0,0,0,3.641-1.423,4.886,4.886,0,0,1,1.07-.719c0,2.167-.4,7.523-4.162,10.46a5,5,0,0,1-2.928,1,25.235,25.235,0,0,0,2.381-5.508,1.167,1.167,0,0,0-2.249-.625A21.4,21.4,0,0,1,43.775,15h-1.2a21.606,21.606,0,0,1-2.944-6.148,1.167,1.167,0,0,0-2.248.627,25.253,25.253,0,0,0,2.384,5.513,5.017,5.017,0,0,1-2.989-1.007c-3.759-2.935-4.162-8.292-4.162-10.452a4.563,4.563,0,0,1,1.065.709Z"
                                        transform="translate(0 -0.999)"
                                    />
                                    <path
                                        id="Shape-13"
                                        data-name="Shape"
                                        d="M56,49.044a11.606,11.606,0,0,0,2.22-6.778A1.209,1.209,0,0,0,57.074,41a1.222,1.222,0,0,0-1.266,1.15,9.258,9.258,0,0,1-1.7,5.392c-2.359,2.979-6.834,3.13-7.709,3.13a1.209,1.209,0,1,0,0,2.418C47.468,53.09,52.953,52.9,56,49.044Z"
                                        transform="translate(6.909 5.332)"
                                    />
                                    <path
                                        id="Shape-14"
                                        data-name="Shape"
                                        d="M34.418,37.508a1.209,1.209,0,1,0-2.418,0,4.836,4.836,0,0,0,4.836,4.836v1.209a1.209,1.209,0,0,0,2.418,0V42.344a4.836,4.836,0,1,0,0-9.672V27.836a2.418,2.418,0,0,1,2.418,2.418,1.209,1.209,0,0,0,2.418,0,4.836,4.836,0,0,0-4.836-4.836V24.209a1.209,1.209,0,0,0-2.418,0v1.209a4.836,4.836,0,0,0,0,9.672v4.836A2.418,2.418,0,0,1,34.418,37.508Zm0-7.254a2.418,2.418,0,0,1,2.418-2.418v4.836A2.418,2.418,0,0,1,34.418,30.254Zm4.836,4.836a2.418,2.418,0,0,1,0,4.836Z"
                                        transform="translate(5.065 2.271)"
                                    />
                                </g>
                            </svg>
                        </div>

                        <div>
                            <h3 class=" text-lg md:text-xl font-bold ">
                                Earn more
                            </h3>
                            <p class=" text-sm md:text-base">
                                You haven't started referring.
                            </p>
                        </div>
                    </div>

                    <button
                        class="px-4 py-2  text-sm md:text-base font-medium text-primary bg-gray-200  rounded-md ml-2 md:ml-0 mt-2 md:mt-0 "
                        onClick={handleReferNowClick}
                    >
                        Start referring
                    </button>
                </div>
            ) : (
                <div className="">
                    {/* <div className="flex">
                        <div className="w-[60%] lg:w-[30%] flex-grow ">
                            <div className="flex items-center justify-between">
                                <div>
                                    <h1 className="text-black text-lg md:text-xl font-bold">
                                        Past Referral List
                                    </h1>
                                </div>

                                {hasReferrals && (
                                    <div className="">
                                        <button
                                            className="bg-primary text-white px-3 py-[6px] md:px-4 md:py-2 rounded-md"
                                            onClick={handleReferNowClick}
                                        >
                                            Earn More
                                        </button>
                                    </div>
                                )}
                            </div>

                            <p className="font-Poppins pt-1 text-sm whitespace-nowrap">
                                All your cashback information comes here
                            </p>
                        </div>
                    </div> */}
                    {userRole != 'EMPLOYEE' && (
                        <div
                            id="pastReferrals"
                            className="py-7 lg:pt-10 border-[#EBEAF2]"
                        >
                            <div className="flex lg:items-center">
                                <div className="hidden lg:flex lg:flex-row lg:gap-x-8 xl:gap-x-16">
                                    <div
                                        onClick={() => changeStatus('all')}
                                        className={`flex items-center gap-1 cursor-pointer ${
                                            active == 'all'
                                                ? 'text-primary font-bold'
                                                : 'text-black'
                                        }`}
                                    >
                                        <h3>All</h3>
                                        <h1>
                                            (
                                            {userAccountSummary?.leadSubmissions ||
                                                '0'}
                                            )
                                        </h1>
                                    </div>
                                    <div
                                        onClick={() =>
                                            changeStatus('sitevisit')
                                        }
                                        className={`flex items-center gap-1  cursor-pointer ${
                                            active == 'sitevisit'
                                                ? 'text-primary font-bold'
                                                : ''
                                        }`}
                                    >
                                        <h3>Site Visit</h3>
                                        <h3>
                                            (
                                            {userAccountSummary?.siteVisits ||
                                                '0'}
                                            )
                                        </h3>
                                    </div>
                                    <div
                                        onClick={() => changeStatus('booking')}
                                        className={`flex items-center gap-1  cursor-pointer ${
                                            active == 'booking'
                                                ? 'text-primary font-bold'
                                                : ''
                                        }`}
                                    >
                                        <h3>Booking</h3>
                                        <h3>
                                            (
                                            {userAccountSummary?.bookingsDone ||
                                                '0'}
                                            )
                                        </h3>
                                    </div>
                                    <div
                                        onClick={() =>
                                            changeStatus('registration')
                                        }
                                        className={`flex items-center gap-1 cursor-pointer ${
                                            active == 'registration'
                                                ? 'text-primary font-bold'
                                                : ''
                                        }`}
                                    >
                                        <h3>Registration</h3>
                                        <h3>
                                            (
                                            {userAccountSummary?.registrationsDone ||
                                                '0'}
                                            )
                                        </h3>
                                    </div>
                                    <div
                                        onClick={() => changeStatus('claimed')}
                                        className={`flex items-center gap-1 cursor-pointer ${
                                            active == 'claimed'
                                                ? 'text-primary font-bold'
                                                : ''
                                        }`}
                                    >
                                        <h3>Claimed</h3>
                                        <h3>
                                            (
                                            {userAccountSummary?.claimedCount ||
                                                '0'}
                                            )
                                        </h3>
                                    </div>
                                    <div
                                        onClick={() => changeStatus('rewarded')}
                                        className={`flex items-center gap-1 cursor-pointer ${
                                            active == 'rewarded'
                                                ? 'text-primary font-bold'
                                                : ''
                                        }`}
                                    >
                                        <h3>Rewarded</h3>
                                        <h3>
                                            (
                                            {userAccountSummary?.rewardedCount ||
                                                '0'}
                                            )
                                        </h3>
                                    </div>
                                </div>
                                {/* Mobile view */}
                                <div className="overflow-x-auto scrollbar-thin scrollbar-track-gray-400">
                                    <div className="flex justify-between gap-x-7  md:gap-x-20 mb-6 lg:hidden">
                                        <div
                                            onClick={() => changeStatus('all')}
                                            className={`flex flex-col items-center gap-[2px] cursor-pointer ${
                                                active == 'all'
                                                    ? 'text-primary font-bold'
                                                    : ''
                                            }`}
                                        >
                                            <h3>All</h3>
                                            <h1>
                                                (
                                                {userAccountSummary?.leadSubmissions ||
                                                    '0'}
                                                )
                                            </h1>
                                        </div>
                                        <div
                                            onClick={() =>
                                                changeStatus('sitevisit')
                                            }
                                            className={`flex flex-col items-center gap-[2px] cursor-pointer ${
                                                active == 'sitevisit'
                                                    ? ' text-primary font-bold'
                                                    : ''
                                            }`}
                                        >
                                            <h3 className="whitespace-nowrap">
                                                Site Visit
                                            </h3>
                                            <h3>
                                                (
                                                {userAccountSummary?.siteVisits ||
                                                    '0'}
                                                )
                                            </h3>
                                        </div>
                                        <div
                                            onClick={() =>
                                                changeStatus('booking')
                                            }
                                            className={`flex flex-col items-center gap-[2px] cursor-pointer ${
                                                active == 'booking'
                                                    ? 'text-primary font-bold'
                                                    : ''
                                            }`}
                                        >
                                            <h3>Booking</h3>
                                            <h3>
                                                (
                                                {userAccountSummary?.bookingsDone ||
                                                    '0'}
                                                )
                                            </h3>
                                        </div>
                                        <div
                                            onClick={() =>
                                                changeStatus('registration')
                                            }
                                            className={`flex flex-col items-center gap-[2px] cursor-pointer ${
                                                active == 'registration'
                                                    ? 'text-primary font-bold'
                                                    : ''
                                            }`}
                                        >
                                            <h3>Registration</h3>
                                            <h3>
                                                (
                                                {userAccountSummary?.registrationsDone ||
                                                    '0'}
                                                )
                                            </h3>
                                        </div>
                                        <div
                                            onClick={() =>
                                                changeStatus('claimed')
                                            }
                                            className={`flex flex-col items-center gap-[2px] cursor-pointer ${
                                                active == 'claimed'
                                                    ? 'text-primary font-bold'
                                                    : ''
                                            }`}
                                        >
                                            <h3>Claimed</h3>
                                            <h3>
                                                (
                                                {userAccountSummary?.claimedCount ||
                                                    '0'}
                                                )
                                            </h3>
                                        </div>
                                        <div
                                            onClick={() =>
                                                changeStatus('rewarded')
                                            }
                                            className={`flex flex-col items-center gap-[2px] cursor-pointer ${
                                                active == 'rewarded'
                                                    ? 'text-primary font-bold'
                                                    : ''
                                            }`}
                                        >
                                            <h3>Rewarded</h3>
                                            <h3>
                                                (
                                                {userAccountSummary?.rewardedCount ||
                                                    '0'}
                                                )
                                            </h3>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <hr
                                className={`hidden md:block h-2 mt-5 ${
                                    config?.darkMode
                                        ? 'bg-base-content'
                                        : 'bg-[#EBEAF2]'
                                }`}
                            />
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};

export default TotalReferral;
